import { RebodyPattern } from 'src/api/response/catalog';
import { CatalogBodyVariableItem, CatalogItem, CatalogNormalItem } from '../CatalogItem';
import { CatalogItemColor } from '../CatalogItemColor';
import { CatalogItemKey } from '../CatalogItemKey';
import { CatalogItemWithKey } from '../CatalogItemWithKey';

// color1 のみをチェックする関数
export function findMatchColor(
  color: CatalogItemColor,
  item: CatalogItem
): CatalogItemWithKey | undefined {
  switch (item.type) {
    case 'normal':
      const normalReferenceColor1 = resolveNormalItemColor1(item);

      if (normalReferenceColor1 === color) {
        const key = { unique_id: item.unique_id };
        return { key, data: item };
      } else {
        return undefined;
      }
    case 'body-variable':
      if (!item.rebody_pattern) {
        return undefined;
      }
      for (const rp of item.rebody_pattern) {
        const bodyVariableReferenceColor1 = resolveBodyVariableItemColor1(item, rp);

        if (bodyVariableReferenceColor1 === color) {
          const key: CatalogItemKey = { unique_id: item.unique_id, rebody_index: rp.index };
          return { key, data: item };
        }
      }

      return undefined;
    case 'color-variable':
      for (const v of item.variations) {
        if (v.color1 === color) {
          const key = { unique_id: v.unique_id };
          return { key, data: item };
        }
      }
      return undefined;
    default:
      return undefined;
  }
}

// Parkの仕様に基づき、色の判定に使用する色を決定する。
// see https://spdlybra.nintendo.co.jp/confluence/pages/viewpage.action?pageId=929385320

function resolveNormalItemColor1(item: CatalogNormalItem) {
  if (item.color1 && item.color1 !== 'None') {
    return item.color1;
  }
  if (item.refabric_pattern0_color0 && item.refabric_pattern0_color0 !== 'None') {
    return item.refabric_pattern0_color0;
  }
  return 'None';
}

function resolveBodyVariableItemColor1(
  item: CatalogBodyVariableItem,
  rebodyPattern: RebodyPattern
) {
  if (rebodyPattern.color0 !== 'None') {
    return rebodyPattern.color0;
  }
  if (item.color1 && item.color1 !== 'None') {
    return item.color1;
  }
  if (item.refabric_pattern0_color0 && item.refabric_pattern0_color0 !== 'None') {
    return item.refabric_pattern0_color0;
  }
  return 'None';
}
